import { PureComponent } from 'react';

import ProductLinks from 'Component/ProductLinks';
import ShowMore from 'Component/ShowMore';

import { RELATED } from 'Store/LinkedProducts/LinkedProducts.reducer';

import './ProductRelated.style';

export class ProductRelated extends PureComponent {
    render() {
        const { areDetailsLoaded } = this.props;

        return (
            <ShowMore mix={ { block: 'ProductRelated' } }>
                <ProductLinks
                    linkType={ RELATED }
                    title={ __("Product related") }
                    areDetailsLoaded={ areDetailsLoaded }
                />
            </ShowMore>
        );
    }
}

export default ProductRelated;
